const sfBaseHandles = {"8347880587414": "bracelet-charm", "8359093862550": "necklace-pearl", "8387207528598": "paperclip-chain", "8399507030166": "medium-link-paperclip-chain-charm", "8408582094998": "fresh-water-pearl-necklace-2", "8551272579222": "pvd-stainless-steel-chunky-necklace", "8551274446998": "pvd-stainless-steel-fresh-water-pearl-necklace", "8592995713174": "gold-filled-thin-chain", "8592996204694": "pvd-gold-plated-stainless-steel-bracelet", "8596735492246": "16-inch-pvd-gold-plated-stainless-steel-curb-chain-charm-holder", "8602036043926": "handkerchief-necklace", "8602058227862": "textured-pvd-gold-played-stainless-steel-bracelet", "8603183251606": "thin-link-paperclip-bracelet", "8651654430870": "stainless-steel-silver-paperclip-necklace", "8651659673750": "stainless-steel-paperclip-bracelet", "8659002425494": "14k-ion-pvd-plated-silver-bracelet", "8664717033622": "large-thin-link-paperclip-necklace", "8681197469846": "gold-filled-flat-cable-chain", "8681197502614": "thin-link-pvd-necklace", "8693663694998": "pearl-paperclip-chain", "10314844143766": "pvd-think-cable-chain", "15391168168086": "charm-bar-bracelets"};
(() => {
  function setup() {
    document.querySelectorAll('charm-bar-builder').forEach(builder => {
      const picker = builder.querySelector('.sf-charm-category-picker');
      if (!picker || builder.dataset.sfToolsReady) return;
      builder.dataset.sfToolsReady = 'true';
      const baseSection = builder.querySelector('.charm_bar__base-products-section');
      if (baseSection) baseSection.id = 'sf-builder-start';
      const controls = document.createElement('div');
      controls.className = 'sf-builder-filters';
      controls.innerHTML = '<label>Search charms<input type="search" placeholder="Try heart, pearl, or a letter" aria-label="Search charms"></label><p role="status" aria-live="polite" class="sf-filter-status"></p>';
      picker.append(controls);
      const search = controls.querySelector('input[type="search"]');
      const status = controls.querySelector('.sf-filter-status');
      function filter() {
        const words = search.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
        let count = 0;
        builder.querySelectorAll('.charm_bar__collection-item').forEach(section => {
          section.querySelectorAll('.charm_bar__charm-item').forEach(card => {
            const name = (card.dataset.charmName || '').toLowerCase();
            const matches = words.every(word => name.includes(word));
            card.toggleAttribute('data-sf-filter-hidden', !matches);
            if (matches && !section.hidden && !card.hasAttribute('data-sf-metal-hidden') && card.dataset.productId !== '8627164414102') count++;
          });
        });
        status.textContent = count ? count + ' matching charms in this category' : 'No matching charms. Try another category or clear the search.';
      }
      controls.addEventListener('input', filter);
      controls.addEventListener('change', filter);
      picker.addEventListener('click', event => { if (event.target.closest('.sf-charm-category-buttons')) requestAnimationFrame(filter); });
      filter();
      const notice = document.createElement('p');
      notice.className = 'sf-base-stock-notice';
      notice.setAttribute('role', 'status');
      baseSection?.append(notice);
      const cards = Array.from(builder.querySelectorAll('.charm_bar__base-product-item'));
      function stockMessage() {
        const selected = cards.find(card => card.querySelector('input:checked'));
        notice.textContent = selected?.dataset.sfSoldOut === 'true' ? 'This chain is sold out. Please choose another bracelet or necklace.' : '';
      }
      builder.addEventListener('change', stockMessage);
      builder.addEventListener('click', event => {
        const card = event.target.closest('.charm_bar__base-product-item');
        if (card?.dataset.sfSoldOut === 'true') { event.preventDefault(); event.stopImmediatePropagation(); notice.textContent = 'This chain is sold out. Please choose another bracelet or necklace.'; }
        if (event.target.closest('#charm_bar__add-to-cart-button') && cards.some(c => c.dataset.sfSoldOut === 'true' && c.querySelector('input:checked'))) { event.preventDefault(); event.stopImmediatePropagation(); stockMessage(); baseSection?.scrollIntoView({block:'start'}); }
      }, true);
      const queue = cards.slice();
      async function checkNext() {
        while (queue.length) {
          const card = queue.shift();
          const handle = sfBaseHandles[card.dataset.baseProductId];
          if (!handle) continue;
          try {
            const response = await fetch('/products/' + encodeURIComponent(handle) + '.js');
            if (!response.ok) continue;
            const product = await response.json();
            if (product.available !== false) continue;
            card.dataset.sfSoldOut = 'true';
            const input = card.querySelector('input[type="radio"]');
            if (input) input.disabled = true;
            const label = document.createElement('span');
            label.className = 'sf-base-sold-out';
            label.textContent = 'Sold out';
            card.append(label);
            stockMessage();
          } catch {}
        }
      }
      Promise.all([checkNext(), checkNext(), checkNext(), checkNext()]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

